import {SortAscIcon, SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'
import {useSearchParams, useNavigate} from '@github-ui/use-navigate'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useCallback} from 'react'

export function LabelSortMenu() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const currentSort = searchParams.get('sort')

  let option: 'name' | 'count' | undefined = 'name'
  let direction: 'asc' | 'desc' | undefined = 'asc'

  if (currentSort) {
    const [optionPart, directionPart] = currentSort.split('-')
    option = optionPart as 'name' | 'count'
    direction = directionPart as 'asc' | 'desc'
  }

  const onSelectOption = useCallback(
    (newOption: 'name' | 'count') => {
      if (newOption === option) return
      const params = new URLSearchParams(searchParams)
      params.set('sort', `${newOption}-${direction}`)

      const href = `${ssrSafeWindow?.location.pathname}?${params.toString()}`
      navigate(href)
    },
    [direction, searchParams, navigate, option],
  )

  const onSelectDirection = useCallback(
    (newDirection: 'asc' | 'desc') => {
      if (newDirection === direction) return
      const params = new URLSearchParams(searchParams)
      params.set('sort', `${option}-${newDirection}`)

      const href = `${ssrSafeWindow?.location.pathname}?${params.toString()}`
      navigate(href)
    },
    [direction, navigate, option, searchParams],
  )

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" leadingVisual={SortDescIcon}>
        Sort
      </ActionMenu.Button>

      <ActionMenu.Overlay>
        <ActionList selectionVariant="single">
          <ActionList.Group>
            <ActionList.GroupHeading>Sort by</ActionList.GroupHeading>
            <ActionList.Item onSelect={() => onSelectOption('name')} selected={option === 'name'}>
              Name
            </ActionList.Item>
            {/* Keeping it commented the option in the menu until we support ordering by issue count. */}
            {/* <ActionList.Item onSelect={() => onSelectOption('count')} selected={option === 'count'}>
              Total issue count
            </ActionList.Item> */}
          </ActionList.Group>
          <ActionList.Group>
            <ActionList.GroupHeading>Order</ActionList.GroupHeading>
            <ActionList.Item key="ascending" selected={direction === 'asc'} onSelect={() => onSelectDirection('asc')}>
              <ActionList.LeadingVisual>
                <SortAscIcon />
              </ActionList.LeadingVisual>
              Ascending
            </ActionList.Item>
            <ActionList.Item
              key="descending"
              selected={direction === 'desc'}
              onSelect={() => onSelectDirection('desc')}
            >
              <ActionList.LeadingVisual>
                <SortDescIcon />
              </ActionList.LeadingVisual>
              Descending
            </ActionList.Item>
          </ActionList.Group>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ LabelSortMenu.displayName ||= 'LabelSortMenu' } catch {}